<template>
    <router-view v-if="init"/>
</template>

<script>
import {mapActions} from 'vuex';
import Timer from "@/service/timer";

export default {
    name: 'App',

    data: () => ({
        init: false,
    }),

    async created() {
        let prevErr = null;
        this.timer = new Timer(1500, async () => {
            try {
                await this.fetchCurrentUser();
            } catch(err) {
                if (prevErr !== err.message) {
                    console.error(err);
                    prevErr = err.message;
                }
            } finally {
                this.init = true;
            }

        }, true);
        this.timer.start();
    },

    methods: {
        ...mapActions(['fetchCurrentUser']),
    },
};
</script>

<style>
.v-dialog--fullscreen, .v-toolbar {
    border-top-left-radius: unset !important;
    border-top-right-radius: unset !important;
}
</style>